module.exports = __webpack_public_path__ + "img/mat_logo.8828cbe1.svg";